import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { fmtDateTime } from "@/lib/constants";

export default function AdminLeads() {
  const [leads, setLeads] = useState([]);
  const [loading, setLoading] = useState(true);
  useEffect(() => { api.get("/contact-leads").then(r => setLeads(r.data)).finally(() => setLoading(false)); }, []);

  return (
    <div className="space-y-6" data-testid="admin-leads">
      <h1 className="font-display text-3xl font-bold text-court">Contact leads</h1>
      {loading ? <div className="text-muted-foreground">Loading…</div> : leads.length === 0 ? <div className="text-muted-foreground">No leads yet.</div> : (
        <div className="grid lg:grid-cols-2 gap-4">
          {leads.map(l => (
            <div key={l.id} className="bg-card rounded-sm border border-stone/60 p-6 " data-testid={`lead-card-${l.email}`}>
              <div className="flex items-center justify-between">
                <div>
                  <div className="font-display text-lg text-court">{l.name}</div>
                  <div className="text-xs text-muted-foreground">{l.email} · {l.phone}</div>
                </div>
                <span className="text-xs rounded-sm px-2.5 py-0.5 bg-secondary/10 text-secondary capitalize">{l.type}</span>
              </div>
              <div className="text-sm text-muted-foreground mt-1">{l.organization} · {l.city}</div>
              <div className="mt-3 text-sm whitespace-pre-line">{l.message}</div>
              <div className="mt-3 text-xs text-muted-foreground">{fmtDateTime(l.created_at)}</div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
